/* eslint-disable no-const-assign */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react'
import ReactPaginate from 'react-paginate'

import './PanelList.scss'

import Menu from '../../../components/Menu'
import Table from '../../../components/ShopList'

import { useNavigate } from 'react-router-dom'

import resturantIcon from '../../../assets/svg/resturantIcon.svg'

import { get } from '../../../services/http'
import { notify } from '../../../components/Toast'

export default function index() {
  const [resturants, setResturants] = useState()
  const [resturantCount, setResturantCount] = useState()
  const [totalPage, setTotalPage] = useState()
  
  const navigate = useNavigate()
  document.title = 'رستوران یا کافی شاپ'

  const token = localStorage.getItem('token')

  const navigateHandler = () => {
    navigate('/resturants/create')
  }

  const handlePageClick = (event) => {
    get(`/api/admin/shops?page=${event.selected + 1}&token=${token}`)
      .then(respose => {
        setResturants(respose.data.data.docs)
        setTotalPage(respose.data.data.pages)
        setResturantCount(respose.data.data.total)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }

  useEffect(() => {
    get(`/api/admin/shops?token=${token}`)
      .then(respose => {
        setResturants(respose.data.data.docs)
        setTotalPage(respose.data.data.pages)
        setResturantCount(respose.data.data.total)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [token, totalPage])

  return (
    <main id='panel'>
      <Menu page={'resturant'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={resturantIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                لیست رستوران‌ها یا کافی شاپ‌ها
              </div>
            </div>

            <div className="left">
              <button onClick={navigateHandler}>ایجاد رستوران یا کافی شاپ</button>
            </div>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                تعداد کل رستوران ها یا کافی شاپ ها
              </div>
              <div className="left">
                {resturantCount}
              </div>
            </div>

            <Table data={resturants} />
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
